export const rankTests = [
  {
    id: 'html/css-1',
    topic: 'html/css',
    level: 'Beginner',
    title: 'HTML / CSS',
    total: 2483
  },
  {
    id: 'html/css-2',
    topic: 'html/css',
    level: 'Intermediate',
    title: 'HTML / CSS',
    total: 1783
  },
  {
    id: 'html/css-3',
    topic: 'html/css',
    level: 'Advanced',
    title: 'HTML / CSS',
    total: 683
  },
  {
    id: 'js-1',
    topic: 'js',
    level: 'Beginner',
    title: 'Javascript',
    total: 2483
  },
  {
    id: 'js-2',
    topic: 'js',
    level: 'Intermediate',
    title: 'Javascript',
    total: 1783
  },
  {
    id: 'js-3',
    topic: 'js',
    level: 'Advanced',
    title: 'Javascript',
    total: 683
  },
  {
    id: 'py-1',
    topic: 'py',
    level: 'Beginner',
    title: 'Python',
    total: 2483
  },
  {
    id: 'py-2',
    topic: 'py',
    level: 'Intermediate',
    title: 'Python',
    total: 1783
  },
  {
    id: 'py-3',
    topic: 'py',
    level: 'Advanced',
    title: 'Python',
    total: 683
  },
  {
    id: 'sql-1',
    topic: 'sql',
    level: 'Beginner',
    title: 'SQL',
    total: 2483
  },
  {
    id: 'sql-2',
    topic: 'sql',
    level: 'Intermediate',
    title: 'SQL',
    total: 1783
  },
  {
    id: 'sql-3',
    topic: 'sql',
    level: 'Advanced',
    title: 'SQL',
    total: 683
  },
  {
    id: 'cpp-1',
    topic: 'cpp',
    level: 'Beginner',
    title: 'C++',
    total: 2483
  },
  {
    id: 'cpp-2',
    topic: 'cpp',
    level: 'Intermediate',
    title: 'C++',
    total: 1783
  },
  {
    id: 'cpp-3',
    topic: 'cpp',
    level: 'Advanced',
    title: 'C++',
    total: 683
  }
]
